export default __webpack_public_path__ + "static/media/betterelsewhere.969994b5.jpg";